import { CSSProperties, ReactNode, Ref } from 'react';
import { FloatingPortal } from '@floating-ui/react';

import { cn } from 'support/helpers/cn/cn';

type InfoPopoverProps = {
  style?: CSSProperties;
  children: ReactNode;
  ref?: Ref<HTMLDivElement>;
};
export const InfoPopover = ({ style, children, ref }: InfoPopoverProps) => {
  return (
    <FloatingPortal>
      <div
        className="z-50 w-80 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5"
        ref={ref}
        style={style}
      >
        {children}
      </div>
    </FloatingPortal>
  );
};

export const InfoPopoverBody = ({ children, className }: { children: ReactNode; className?: string }) => {
  return (
    <div className={cn('p-4 *:not-first:mt-2', className)} onMouseDown={(e) => e.preventDefault()}>
      {children}
    </div>
  );
};
export const InfoPopoverFooter = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex w-full justify-between border-t border-gray-200 bg-gray-50 p-2 empty:hidden">{children}</div>
  );
};
